module.exports = __webpack_public_path__ + "static/Baden1-scaled-1614bc3beaf2d1efc1983a9843f9a2e8.jpeg";